import { _getItemsAfterThisWidgetInThisRow } from "./_getItemsAfterThisWidgetInThisRow";
import { _getItemsBeforeThisWidgetInThisRow } from "./_getItemsBeforeThisWidgetInThisRow";
import { _getStartEndColumns } from "./_getStartEndColumns";


export const handleDeleteWidget = ({ widgetIndex, config, setConfig, TOTAL_COLUMNS }) => {
  const [startCol, endCol] = _getStartEndColumns(config[widgetIndex].gridColumn);

  //get items before
  const indexesBefore = _getItemsBeforeThisWidgetInThisRow({
    widgetIndex,
    config,
    setConfig,
    TOTAL_COLUMNS,
    startCol,
  });

  //get items after
  const indexesAfter = _getItemsAfterThisWidgetInThisRow({
    widgetIndex,
    config,
    TOTAL_COLUMNS,
    endCol,
  });

  //since before after is all that will be left, calculate the space distribution for them
  const totalWidgetsLeft = indexesBefore.length + indexesAfter.length;
  const spacePerWidget = Math.floor(TOTAL_COLUMNS / totalWidgetsLeft);
  const spaceForLastWidget =
    TOTAL_COLUMNS - (totalWidgetsLeft - 1) * spacePerWidget;

  //now lets apply the new gridColumns to these before and after widgets
  const modifiedConfig = JSON.parse(JSON.stringify(config));

  const beforeAndAfterIndexes = [...indexesBefore, ...indexesAfter];

  beforeAndAfterIndexes.forEach((index, i) => {
    const startColumn = 1 + spacePerWidget * i;
    if (i !== beforeAndAfterIndexes.length - 1) {
      modifiedConfig[index].gridColumn = `${startColumn} / ${
        startColumn + spacePerWidget
      }`;
    } else {
      modifiedConfig[index].gridColumn = `${startColumn} / ${
        startColumn + spaceForLastWidget
      }`;
    }
  });

  //now lets splice out the widget config we need to delete
  modifiedConfig.splice(widgetIndex, 1);

  setConfig(modifiedConfig);
};